const commonLabels = {
  labels: {
    abort: 'Abort',
    actions: 'Actions',
    active: 'Active',
    add: 'Add',
    address: 'Address',
    amount: 'Amount',
    affiliateCode: 'Affiliate Code',
    and: 'And',
    at: 'At',
    back: 'Back',
    applyFilter: 'Apply Filter',
    balance: 'Balance',
    birthday: 'Birthday',
    blocked: 'Blocked',
    bonuses: 'Bonuses',
    bonusAmount: 'Bonus Amount',
    bonusCode: 'Bonus Code',
    bonusMoney: 'Bonus Money',
    bonusName: 'Bonus Name',
    bonusDescription: 'Bonus Description',
    bonusDetails: 'Bonus Details',
    bonusTrigger: 'Bonus Trigger',
    bonusType: 'Bonus Type',
    byBrand: 'By Brand',
    cancel: 'Cancel',
    cancelled: 'Cancelled',
    casinoReports: 'Casino Reports',
    category: 'Category',
    city: 'City',
    close: 'Close',
    code: 'Code',
    clear: 'Clear',
    comment: 'Comment',
    completed: 'Completed',
    confirm: 'Confirm',
    confirmPassword: 'Confirm Password',
    country: 'Country',
    create: 'Create',
    createdBy: 'Created By',
    createdDate: 'Created Date',
    createdSuccessfully: 'Created Successfully',
    currency: 'Currency',
    currencies: 'Currencies',
    currencyDefault: '(Default)',
    date: 'Date',
    dateRange: 'Date Range',
    dateFrom: 'Date From',
    dateTo: 'Date To',
    daily: 'Daily',
    day: 'Day',
    dashboards: 'Dashboards',
    delete: 'Delete',
    deleteTwo: 'Delete',
    deleted: 'deleted',
    desktop: 'Desktop',
    description: 'Description',
    discard: 'Discard',
    disable: 'Disable',
    downloadAsXLS: 'Download as XLS',
    duplicate: 'Duplicate',
    duplicatedSuccessfully: 'Duplicated Successfully',
    edit: 'Edit',
    email: 'Email',
    emailOptIn: 'Email Opt-In',
    enable: 'Enable',
    endDate: 'End Date',
    endTime: 'End Time',
    exclude: 'Exclude',
    excluded: 'Excluded',
    excludedGames: 'Excluded Games',
    expirationTime: 'Expiration Time',
    false: 'False',
    female: 'Female',
    from: 'From',
    forfeit: 'Forfeit',
    freeSpinQuantity: 'Free Spin Quantity',
    freeSpinsGranted: 'Free Spins Granted',
    game: 'Game',
    games: 'Games',
    gameCategories: 'Game Categories',
    gameCategory: 'Game Category',
    gameProvider: 'Game Provider',
    gender: 'Gender',
    go: 'Go',
    goToPage: 'Go to page',
    goToTheLibrary: 'Go To The Library',
    id: 'ID',
    include: 'Include',
    included: 'Included',
    insert: 'Insert',
    inactive: 'Inactive',
    isBlocked: 'Blocked',
    language: 'Language',
    last7Days: 'Last 7 Days',
    last30Days: 'Last 30 Days',
    lifetime: 'Lifetime',
    limitType: 'Limit Type',
    male: 'Male',
    marketingConsent: 'Marketing Consent',
    maxBonusesAllowed: 'Max Bonuses Allowed',
    mobile: 'Mobile',
    mobileNumber: 'Mobile Number',
    name: 'Name',
    next: 'Next',
    newPassword: 'New Password',
    no: 'No',
    numberCode: 'Number Code',
    role: 'Role',
    options: 'Options',
    optional: '(Optional)',
    or: 'Or',
    gameStoreId: 'Game Store ID',
    overview: 'Overview',
    paused: 'Paused',
    password: 'Password',
    percentage: 'Percentage',
    period: 'Period',
    personalizationEngine: 'Gaming Data',
    performedBy: 'Performed By',
    phoneNumber: 'Mobile Number',
    placeholders: 'Placeholders',
    player: 'Player',
    playerTags: 'Player tags',
    playerId: 'Player ID',
    position: 'Position',
    postalCode: 'Postal Code',
    preview: 'Preview',
    priority: 'Priority',
    provider: 'Provider',
    providerId: 'Provider ID',
    providerName: 'Provider Name',
    providerLogo: 'Provider Logo',
    realMoney: 'Real Money',
    reason: 'Reason',
    recover: 'Recover',
    registrationDate: 'Registration Date',
    regDate: 'Reg. Date',
    registrationIp: 'Reg. IP Address',
    remove: 'Remove',
    removeLanguage: 'Remove Language',
    replyTo: 'Reply to',
    resolve: 'Resolve',
    riskLevel: 'Risk Level',
    rolloverAmount: 'Rollover Amount',
    rolloverCoefficient: 'Rollover Coefficient',
    rolloverContribution: 'Rollover Contribution',
    rowsPerPage: 'Rows',
    salary: 'Salary',
    save: 'Save',
    scheduled: 'Scheduled',
    search: 'Search',
    searchByPlayerId: 'Search by Player ID',
    searchById: 'Search by ID',
    searchByName: 'Search By Name',
    searchByTitle: 'Search By Title',
    searchRules: 'Search Rules',
    searchFilter: 'Search Filter',
    select: 'Select',
    selectAll: 'Select All',
    selectBrand: 'Select Brand',
    selectConditional: 'Select Conditional',
    selectReport: 'Select a Report Type',
    selectGames: 'Select Games',
    selectCategories: 'Select Categories',
    selectProviders: 'Select Providers',
    selectSports: 'Select Sports',
    selectType: 'Select Type',
    selectWagerTypes: 'Select Wager Types',
    setting: 'Setting',
    siteId: 'Site ID',
    smsOptIn: 'SMS Opt-In',
    specificDate: 'Specific Date',
    sports: 'Sports',
    state: 'State',
    startDate: 'Start Date',
    startTime: 'Start Time',
    status: 'Status',
    steps: 'Steps',
    subject: 'Subject',
    timeUnit: 'Time Unit',
    time: 'Time',
    to: 'To',
    today: 'Today',
    type: 'Type',
    typeData: 'Type Data',
    trigger: 'Trigger',
    triggerType: 'Trigger Type',
    title: 'Title',
    total: 'Total',
    transactions: 'Transactions',
    transactionTypePayment: 'Balance Type',
    tryAgain: 'Try again',
    true: 'True',
    twoFAAuthentication: 'Two-Factor Authentication',
    update: 'Update',
    updated: 'Updated',
    updatedSuccessfully: 'Updated successfully',
    unSelectAll: 'Unselect All',
    username: 'Username',
    value: 'Value',
    valueMin: 'Min',
    valueMax: 'Max',
    yearsText: 'years old',
    yes: 'Yes',
    yesContinue: 'Yes, Continue',
    wageringContribution: 'Wagering Contribution',
    wagerTypes: 'Wager Types',
    walletBalanceAfter: 'Wallet Balance After',
    walletId: 'Wallet ID',
    weekday: 'Weekday',
    zipCode: 'Zip Code',
  },
  status: {
    enabled: 'Enabled',
    disabled: 'Disabled',
  },
}
export default commonLabels
